import React from 'react';

// Material UI
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material';

// Utils
import trustLoading from '../../assets/img/trustLoading.svg';
import trustLoadingDark from '../../assets/img/trustLoadingDark.svg';
import trustSuccess from '../../assets/img/trustSuccess.svg';
import trustSuccessDark from '../../assets/img/trustSuccessDark.svg';
import trustError from '../../assets/img/trustError.svg';
import trustErrorDark from '../../assets/img/trustErrorDark.svg';
import trustCheck from '../../assets/img/trustCheck.svg';
import trustCheckDark from '../../assets/img/trustCheckDark.svg';
import trustErrorImage from '../../assets/img/trustErrorImage.svg';
import trustErrorImageDark from '../../assets/img/trustErrorImageDark.svg';

export const Trustness = ({
    score,
    verified,
    checking,
    type,
    disabled,
    onExpertVerification,
    ...props
}) => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const successTooltip = () => {
        return (
            <Grid container alignItems={'center'}>
                <Grid item xs={12}>
                    <Grid container alignItems={'center'}>
                        <Grid item xs={1}>
                            <img
                                src={
                                    theme.palette.mode === 'light'
                                        ? trustCheck
                                        : trustCheckDark
                                }
                                alt=""
                            />
                        </Grid>
                        <Grid item>
                            <Typography variant={'body2'}>
                                Cryptographic Signature Validated
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container alignItems={'center'}>
                        <Grid item xs={1}>
                            <img
                                src={
                                    theme.palette.mode === 'light'
                                        ? trustCheck
                                        : trustCheckDark
                                }
                                alt=""
                            />
                        </Grid>
                        <Grid item>
                            <Typography variant={'body2'}>
                                Network Validation Verified
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container alignItems={'center'}>
                        <Grid item xs={1}>
                            <img
                                src={
                                    theme.palette.mode === 'light'
                                        ? trustCheck
                                        : trustCheckDark
                                }
                                alt=""
                            />
                        </Grid>
                        <Grid item>
                            <Typography variant={'body2'}>
                                Proof of Authenticity Passed
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const errorTooltip = () => {
        return (
            <Grid container justifyContent={'center'}>
                <Grid item>
                    <img
                        src={
                            theme.palette.mode === 'light'
                                ? trustErrorImage
                                : trustErrorImageDark
                        }
                        alt=""
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={{ textAlign: 'center' }} variant={'body2'}>
                        The system was not able to verify this content at this
                        time. Please come back later when the proof of
                        authenticity will be recorded.
                    </Typography>
                </Grid>
            </Grid>
        );
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
                sx={{ m: 1, position: 'relative' }}
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            >
                {checking ? (
                    <img
                        src={
                            theme.palette.mode === 'light'
                                ? trustLoading
                                : trustLoadingDark
                        }
                        alt="Trust Loading"
                        height={30}
                    />
                ) : verified ? (
                    <img
                        src={
                            theme.palette.mode === 'light'
                                ? trustSuccess
                                : trustSuccessDark
                        }
                        alt="Trust Success"
                        height={30}
                    />
                ) : verified === undefined ? (
                    <img
                        src={
                            theme.palette.mode === 'light'
                                ? trustLoading
                                : trustLoadingDark
                        }
                        alt="Trust Loading"
                        height={30}
                    />
                ) : (
                    <img
                        src={
                            theme.palette.mode === 'light'
                                ? trustError
                                : trustErrorDark
                        }
                        alt="Trust Error"
                        height={30}
                    />
                )}
                {checking && (
                    <CircularProgress
                        size={40}
                        thickness={1}
                        sx={{
                            color:
                                theme.palette.mode === 'light'
                                    ? '#414CAE'
                                    : '#7CCBBD',
                            position: 'absolute',
                            top: -6,
                            left: -6,
                            zIndex: 1,
                        }}
                    />
                )}
            </Box>
            <Popover
                id="mouse-over-popover"
                sx={{
                    pointerEvents: 'none',
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
                PaperProps={{
                    style: {
                        borderRadius: 25,
                        border: 'solid #C8C8CC',
                        padding: 10,
                        maxWidth: 322,
                    },
                }}
            >
                {!checking && verified && successTooltip()}
                {!checking && !verified && errorTooltip()}
            </Popover>
        </Box>
    );
};

export default Trustness;
